<app-spinner size="15px"></app-spinner>
<img src="assets/img/icons/search.svg" />

<input type="text" [formControl]="searchFormControl" [placeholder]="placeholder" />
